import React from "react"
import animations from "./animations"
import { motion } from "framer-motion"
import Drone from "./Drone"

export default function Projection({ controls }) {
  const { loop } = animations
  const { mainSequence } = animations

  const towerStroke = {
    fill: "none",
    stroke: "#4FC3F6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
  }

  return (
    <>
      <motion.g {...loop.projectionFloat}>
        <Drone {...{ controls }} />

        {/* GROUP 1 */}
        <motion.g
          variants={mainSequence.group1.position}
          animate={controls}
          initial={{ opacity: 1 }}
        >
          <polygon
            fill="url(#tower-floor-plane)"
            points="292,244.7 273.8,255.2 255.6,244.7 273.7,235.5"
          />
          <polygon
            fill="url(#tower-right-plane)"
            points="292,178.5 292,244.6 273.8,255.2 273.9,189"
          />
          <polygon
            fill="url(#tower-left-plane)"
            points="273.9,189 273.8,255.2 255.6,244.6 255.6,178.5"
          />
          <polygon
            fill="url(#tower-roof-plane)"
            points="292,178.5 273.9,189 255.6,178.5 273.8,167.9"
          />
          <motion.polygon
            {...towerStroke}
            animate={controls}
            variants={mainSequence.group1.focus}
            initial={{ opacity: 0.1 }}
            points="255.6,244.5 255.7,178.5 273.9,168 292,178.5 292,244.5 273.9,255.2"
          ></motion.polygon>
          <motion.g
            animate={controls}
            variants={mainSequence.group1.graphics.graphic1}
            initial={{
              opacity: 0,
              scale: 0.8,
            }}
          >
            <motion.path
              initial={{
                opacity: 0.5,
              }}
              animate={controls}
              variants={mainSequence.group1.graphics.graphic1.part1}
              fill="#4FC3F6"
              d="M226,170.8V189h18.2C244.2,178.9,236,170.8,226,170.8z"
            />
            <motion.path
              initial={{
                opacity: 0.5,
              }}
              animate={controls}
              variants={mainSequence.group1.graphics.graphic1.part2}
              fill="#4FC3F6"
              d="M226,207.2c-4.7,0-9.3-1.8-12.9-5.3L226,189h18.2C244.2,199,236,207.2,226,207.2z"
            />
            <path
              fill="#4FC3F6"
              style={{
                opacity: 0.5,
              }}
              d="M207.8,189c0,5,2,9.6,5.3,12.9L226,189v-18.2C215.9,170.8,207.8,178.9,207.8,189z"
            />
          </motion.g>
          <motion.ellipse
            variants={mainSequence.group1.graphics.graphic2}
            animate={controls}
            initial={{
              strokeDashoffset: 100,
              opacity: 0.82,
              scale: 0.8,
            }}
            fill="none"
            stroke="#4FC3F6"
            strokeWidth={8}
            strokeDasharray={100}
            cx={227}
            cy={235}
            rx={14}
            ry={14}
          />
        </motion.g>

        {/* GROUP 2 */}
        <motion.g
          animate={controls}
          variants={mainSequence.group2.position}
          initial={{ opacity: 1 }}
        >
          <polygon
            fill="url(#tower-floor-plane)"
            points="194.4,244.7 176.3,255.2 158,244.7 176.2,234.1"
          />
          <polygon
            fill="url(#tower-right-plane)"
            points="194.3,178.5 194.3,244.6 176.1,255.2 176.2,189"
          />

          <polygon
            fill="url(#tower-left-plane)"
            opacity="1"
            points="176.2,189 176.1,255.2 157.9,244.6 157.9,178.5"
          />
          <polygon
            fill="url(#tower-roof-plane)"
            points="194.3,178.5 176.2,189 157.9,178.5 176.1,167.9"
          />
          <motion.polygon
            opacity="0.1"
            animate={controls}
            variants={mainSequence.group2.focus}
            {...towerStroke}
            points="157.9,244.5 157.9,178.5 176.2,168 194.3,178.5 194.3,244.5 176.2,255.2"
          />

          <motion.polyline
            initial={{
              strokeDashoffset: 100,
              strokeDasharray: 100,
              opacity: 0.82,
            }}
            animate={controls}
            variants={mainSequence.group2.graphics.graphic2}
            {...towerStroke}
            points="200,180 210,180 210,243 200,243"
          />
          <motion.polyline
            points="198,248 204,251 188,261 182,258"
            initial={{
              strokeDashoffset: 100,
              strokeDasharray: 100,
              opacity: 0.82,
            }}
            animate={controls}
            variants={mainSequence.group2.graphics.graphic3}
            {...towerStroke}
          />

          <motion.g
            animate={controls}
            variants={mainSequence.group2.graphics.graphic1}
          >
            {[
              "220,190 250,190",
              "220,195 240,195",
              "220,200 230,200",
              "220,205 240,205",
              "220,210 235,210",
            ].map((node, index) => (
              <motion.polyline
                key={index}
                points={node}
                initial={{
                  strokeDashoffset: 100,
                  strokeDasharray: 100,
                  opacity: 0.82,
                }}
                variants={mainSequence.group2.graphics.graphic1.part1}
                {...towerStroke}
              />
            ))}
          </motion.g>
        </motion.g>

        {/* GROUP 3 */}
        <motion.g
          animate={controls}
          variants={mainSequence.group3.position}
          initial={{ opacity: 1 }}
        >
          <motion.polygon
            animate={controls}
            variants={mainSequence.group3.focus}
            {...towerStroke}
            opacity="0.1"
            points="207.3,272.4 207.4,157.3 225.6,146.8 243.7,157.3 243.7,272.4 225.6,283.2"
          />

          <motion.polyline
            initial={{
              strokeDashoffset: 200,
              strokeDasharray: 200,
              opacity: 0.82,
            }}
            {...towerStroke}
            animate={controls}
            variants={mainSequence.group3.graphics.graphic1}
            points="264,165 260,165 260,135 290,135 290,155 278,155 278,165 274,165"
          />

          <motion.polyline
            initial={{
              strokeDashoffset: 200,
              strokeDasharray: 200,
              opacity: 0.82,
            }}
            {...towerStroke}
            animate={controls}
            variants={mainSequence.group3.graphics.graphic1}
            points="188,263 192,263 192,293 174,293 174,287 152,287 152,259 172,259 172,263 176,263"
          />

          <motion.polyline
            initial={{
              strokeDashoffset: 100,
              strokeDasharray: 100,
              opacity: 0.82,
            }}
            {...towerStroke}
            animate={controls}
            variants={mainSequence.group3.graphics.graphic2}
            {...towerStroke}
            points="248,195 253,195 269,176 269,171"
          />

          <motion.polyline
            initial={{
              strokeDashoffset: 100,
              strokeDasharray: 100,
              opacity: 0.82,
            }}
            {...towerStroke}
            animate={controls}
            variants={mainSequence.group3.graphics.graphic2}
            {...towerStroke}
            points="203,230 198,230 182,249 182,254"
          />

          <motion.polygon
            initial={{ opacity: 0 }}
            animate={controls}
            variants={mainSequence.group3.graphics.graphic3}
            fill="url(#tower-floor-plane)"
            points="243.7,195.7 225.6,206.2 207.3,195.7 225.5,185.1"
          />

          <motion.polygon
            initial={{ opacity: 0 }}
            animate={controls}
            variants={mainSequence.group3.graphics.graphic3}
            fill="url(#tower-floor-plane)"
            points="243.7,230.7 225.6,241.2 207.3,230.7 225.5,220.1"
          />

          <motion.g
            animate={controls}
            variants={mainSequence.group3.graphics.graphic4}
          >
            {[
              "195,170 170,170",
              "195,175 175,175",
              "195,180 185,180",
              "195,185 170,185",
              "195,190 180,190",
              "256,240 276,240",
              "256,245 286,245",
              "256,250 271,250",
              "256,255 276,255",
              "256,260 261,260",
            ].map((node, index) => (
              <motion.polyline
                key={index}
                points={node}
                initial={{
                  strokeDashoffset: 100,
                  strokeDasharray: 100,
                  opacity: 0.82,
                }}
                variants={mainSequence.group3.graphics.graphic4.part1}
                {...towerStroke}
              />
            ))}
          </motion.g>

          <polygon
            fill="url(#tower-floor-plane)"
            points="243.7,272.7 225.6,283.2 207.3,272.7 225.5,262.1"
          />
          <polygon
            fill="url(#tower-right-plane)"
            points="243.7,157.3 243.7,272.6 225.5,283.2 225.6,167.8"
          />
          <polygon
            fill="url(#tower-left-plane)"
            points="225.6,167.8 225.5,283.2 207.3,272.6 207.3,157.3"
          />
          <polygon
            fill="url(#tower-roof-plane)"
            points="243.7,157.3 225.6,167.8 207.3,157.3 225.5,146.7"
          />
        </motion.g>
      </motion.g>
    </>
  )
}
